export const GET_ERRORS = 'GET_ERRORS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';

export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_PRODUCT_SUCCESS = 'GET_PRODUCT_SUCCESS';
export const PRODUCTS_LOADING = 'PRODUCTS_LOADING';
export const GET_MY_PRODUCTS_SUCCESS = 'GET_MY_PRODUCTS_SUCCESS';
export const DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT_SUCCESS';

export const GET_REVIEWS_SUCCESS = 'GET_REVIEWS_SUCCESS';
export const ADD_REVIEW_SUCCESS = 'ADD_REVIEW_SUCCESS';

export const ADD_TO_CART = 'ADD_TO_CART';
export const ADD_OFFER_TO_CART = 'ADD_OFFER_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const UPDATE_CART_QTY = 'UPDATE_CART_QTY';
export const CLEAR_CART = 'CLEAR_CART';

export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS';
export const ADD_ORDER_SUCCESS = 'ADD_ORDER_SUCCESS';
